interface PlayingIconProps {
  className?: string;
  progress?: number; // 0-100的进度值
  progressColor?: string; // 进度条颜色
  progressWidth?: number; // 进度条宽度
}

export default function PlayingIcon({ 
  className, 
  progress = 0, 
  progressColor = "#FFFFFF", // 默认白色
  progressWidth = 2
}: PlayingIconProps) {
  // 计算进度条的路径
  const radius = 9; // 圆形进度条半径
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (progress / 100) * circumference;
  
  // 生成唯一的ID以避免冲突
  const clipId = `clip-playing-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath={`url(#${clipId})`}>
        {/* 原始的播放图标 */}
        <rect width="20" height="20" rx="10" fill="currentColor" />
        <rect x="7" y="7" width="2" height="6" rx="0.5" fill="white" />
        <rect x="11" y="7" width="2" height="6" rx="0.5" fill="white" />
        
        {/* 圆形进度条 */}
        {progress && (
          <>
            {/* 进度条 */}
            <circle
              cx="10"
              cy="10"
              r={radius}
              fill="none"
              stroke={progressColor}
              strokeWidth={progressWidth}
              strokeLinecap="round"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              transform="rotate(-90 10 10)"
            />
          </>
        )}
      </g>
      
      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "PlayingIcon";
